<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit User">
      <div class="row">
        <div class="col-md-4 form-group">
          User Name
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-4 form-group">
          Mobile
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-4 form-group">
          Email
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Registration Number
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Institute/College Name
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Status
          <b-form-select v-model="selected1" :options="options"></b-form-select>
        </div>
      </div>
      <div class="text-center">
      <b-button class="text-center pt-2 pb-2 pr-4 pl-4" variant="success" style="margin-bottom: 20px;" >Save</b-button>
      </div>
    </base-block>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected1: null,
      options: [  
        { text: "Active" },
        { text: "Deactive" }
      ],
    };
  },
};
</script>

